module.exports = __webpack_public_path__ + "2e6b1b39ff3c1fcebcd06c263d8d9033.png";